import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { AuthService } from "../core/auth.service";

// Shown (in place of the whole shell) when the platform owner has suspended the
// current user or their company. There is no in-app remedy — the account is
// locked — so the only action is to sign out.
@Component({
  selector: "app-suspended",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="susp">
      <div class="susp-card">
        <div class="susp-mark">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="4.9" y1="4.9" x2="19.1" y2="19.1" />
          </svg>
        </div>
        <h1>Account suspended</h1>
        <p>
          {{
            auth.user()?.company_banned
              ? "Your company's access has been suspended by the platform administrator."
              : "Your account has been suspended by the platform administrator."
          }}
        </p>
        <p class="susp-sub">
          If you believe this is a mistake, please contact support to resolve it.
        </p>
        <button class="btn btn-primary" (click)="logout()">Sign out</button>
      </div>
    </div>
  `,
  styles: [
    `
      .susp {
        min-height: 100vh;
        display: grid;
        place-items: center;
        padding: 24px;
        background: var(--bg);
      }
      .susp-card {
        max-width: 440px;
        width: 100%;
        text-align: center;
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: 18px;
        padding: 40px 32px;
        box-shadow: var(--shadow-1, 0 10px 30px rgba(0, 0, 0, 0.06));
      }
      .susp-mark {
        width: 64px;
        height: 64px;
        margin: 0 auto 18px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        background: #fde8e8;
        color: #c0392b;
      }
      .susp-mark svg {
        width: 32px;
        height: 32px;
      }
      h1 {
        font-size: 22px;
        margin: 0 0 10px;
      }
      p {
        color: var(--text-2);
        font-size: 14px;
        line-height: 1.5;
        margin: 0 0 8px;
      }
      .susp-sub {
        color: var(--text-3);
        font-size: 13px;
        margin-bottom: 22px;
      }
    `,
  ],
})
export class SuspendedComponent {
  auth = inject(AuthService);
  private router = inject(Router);

  logout() {
    this.auth.logout().subscribe({
      next: () => this.router.navigate(["/login"]),
      error: () => this.router.navigate(["/login"]),
    });
    this.auth.clear();
  }
}
